import {
  TypeCardFilterWithoutUnresolvableLinksResponse,
  TypeFilterCardWithoutUnresolvableLinksResponse,
} from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import { mapTags, ContentfulITag } from 'src/siteBuilder/renderer/contentful/mapTags'
import CardFilter from './CardFilter'

const ContentfulCardFilter = withContentful<TypeCardFilterWithoutUnresolvableLinksResponse['fields']>(CardFilter, {
  heading: (props) => props.fields?.heading,
  filterTags: (props) => mapTags((props.fields?.tags ?? []) as unknown as ContentfulITag[]),
  resultsText: (props) => props.fields?.resultsText,
  enableSearch: (props) => props.fields?.searchBar,
  showLoadMoreBtn: (props) => props.fields?.showLoadMoreBtn,
  buttonText: (props) => props.fields?.buttonText,
  equalCardHeight: (props) => props.fields?.equalCardHeight,
  useSingleTag: (props) => props.fields?.useSingleTag,
  cards: (props) =>
    props.fields?.cards?.map((card) => {
      // cards links to ActivityContainer | FilterCard; this block only handles
      // FilterCard shape (matches the prior code's runtime assumption).
      const { tags, content, background, searchTerms } =
        card.fields as TypeFilterCardWithoutUnresolvableLinksResponse['fields']
      return {
        id: card.sys.id,
        tags: mapTags((tags ?? []) as unknown as ContentfulITag[]),
        background: background?.toLowerCase() as Lowercase<NonNullable<typeof background>>,
        content: <BlockRenderer block={content} fieldPath={'.content'} />,
        searchTerms,
        hasGutter: content?.fields?.hasGutter,
      }
    }),
})

export default ContentfulCardFilter
